<input class="form-check-input" type="checkbox" [(ngModel)]="checked" [ngModelOptions]="{standalone: true}" (change)="onChanged()">
